module.exports = __webpack_public_path__ + "img/chara.f9c32ffc.png";